<template>
  <div class="content">
    <img class="room" v-lazy="require('../../assets/imgs/room_back.png')" />
    <img class="room_img1" v-lazy="require('../../assets/imgs/room_img1.png')" />
    <span class="room_code_title">扫码查看VR全景</span>
    <el-row class="one">
      <el-col :span="24" class="title">
        <img v-lazy="require('../../assets/imgs/room_title1.png')" />
      </el-col>
      <el-col :span="24" class="title_content">以科技之力服务诵与读 承中华之文化培育德与智</el-col>
      <el-col :span="24">
        <img v-lazy="require('../../assets/imgs/room1.png')" />
      </el-col>
    </el-row>
    <el-row class="two">
      <el-col :span="24" class="title">
        <img v-lazy="require('../../assets/imgs/room_title2.png')" />
      </el-col>
      <el-col :span="24" class="title_content">轻松搞定一堂阅读课 听学结合生动高效</el-col>
      <el-col :span="24">
        <el-col :span="3">
          &nbsp;
        </el-col>
        <el-col :span="6">
          <img v-lazy="require('../../assets/imgs/room_titletwo1.png')" />
        </el-col>
        <el-col :span="6">
          <img v-lazy="require('../../assets/imgs/room_titletwo2.png')" />
        </el-col>
        <el-col :span="6">
          <img v-lazy="require('../../assets/imgs/room_titletwo3.png')" />
        </el-col>
        <el-col :span="3">
          &nbsp;
        </el-col>
      </el-col>
      <el-col :span="24" class="towImg">
        <img v-lazy="require('../../assets/imgs/room2.png')" />
      </el-col>
    </el-row>
    <el-row class="three">
      <el-col :span="24" class="title">
        <img v-lazy="require('../../assets/imgs/room_title3.png')" />
      </el-col>
      <el-col :span="24" class="title_content">赋能朗读 视听说一体 教学体验全面提升</el-col>
      <el-col :span="24">
        <img v-lazy="require('../../assets/imgs/room3.png')" />
      </el-col>
    </el-row>
    <el-row class="four">
      <el-col :span="24" class="title">
        <img v-lazy="require('../../assets/imgs/room_title4.png')" />
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
      <el-col :span="20">
        <div>
          <el-carousel type="card" trigger="click" :loop="true" height="500px" indicator-position="outside">
            <el-carousel-item>
              <img v-lazy="require('../../assets/imgs/Reading_room2.png')" />
            </el-carousel-item>
            <el-carousel-item>
              <img v-lazy="require('../../assets/imgs/The_classroom.png')" />
            </el-carousel-item>
            <el-carousel-item>
              <img v-lazy="require('../../assets/imgs/The_library1.png')" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
      <el-col :span="2">&nbsp;</el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "pcRoom",
  data () {
    return {
      msg: "这是PC的阅读室宣传页",

    };
  }
};
</script>

<style scoped>
.room {
  position: absolute;
  top: -27vh;
  left: 22vw;
}
.title {
  margin-bottom: 2vh;
  margin-top: 10vh;
}
.room_img1 {
  position: absolute;
  top: -40vh;
  right: 20vw;
  width: 10vw;
}
.room_code_title {
  position: absolute;
  top: -18vh;
  font-size: 22px;
  font-weight: bolder;
  right: 20vw;
  width: 10vw;
}
.title_content {
  font-size: 25px;
  color: #999999;
  margin-bottom: 3vh;
}
.towImg {
  position: relative;
  top: -15vh;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/room.vue